/* 全局常量 */
window.$conf = {};
// window.$conf.baseUrl = "https://yun-test.honsenflag.com/api/";	// 请求地址
window.$conf.baseUrl = "https://www-test.honsenflag.com/api/" //请求地址
// window.$conf.baseUrl = "http://192.168.1.102:8090/"
window.$conf.socketUrl = window.$conf.baseUrl.replace(/\/api\//, '')

if( process.env.NODE_ENV == 'production' ){
	if(window.location.origin == 'https://www-test.honsenflag.com'){
		window.$conf.baseUrl = "https://www-test.honsenflag.com/api/"
		window.$conf.socketUrl = window.$conf.baseUrl.replace(/\/api\//, '')
	}else if(window.location.origin == 'https://www.honsenflag.com'){
		window.$conf.baseUrl = "https://www.honsenflag.com/newapi/"
		window.$conf.socketUrl = window.$conf.baseUrl.replace(/\/newapi\//, '')
	}
  // window.$conf.baseUrl = window.location.origin
}
// window.$conf.socketUrl = window.$conf.baseUrl.replace(/\/api\//, '')
// window.$conf.socketUrl = window.$conf.baseUrl
// window.$conf.socketUrl = 'http://114.55.173.140:3000';
window.$conf.RETCODE_OK = 0;	// 返回码
window.HONSEN_id = 398;
window.RETCODE_OK = 0;
window.imgUrl = $conf.baseUrl.substring(0,$conf.baseUrl.length - 1);



// WEBPACK FOOTER //
// ./src/config.js